export const eventTypes = {
  lia: {
    ticket_comment: 'issue_comment',
    ticket_status_changed: 'issue_status_changed',
    ticket_created: 'issue_created',
    ticket_assignee_changed: 'issue_assignee_changed',
  },
};

export const colorsForActions = {
  open: 'purple',
  actionTaken: 'cyan',
  closed: 'default',
  acknowledged: 'orange',
};

export const colorsForTag = ['magenta', 'red', 'volcano', 'orange', 'gold', 'lime', 'green', 'cyan', 'blue', 'geekblue', 'purple'];

export const notificationSettings = [
  {
    label: 'LIA Co-Pilot',
    value: 'lia',
  },
];

export const NOTIFICATION_COLLECTION = 'notification';
export const USER_PREFERENCE_COLLECTION= 'userPreference';
export const USER_NOTIFICATION_COUNT_COLLECTION = 'userNotificationCount';
